/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        Request.js
//   Object:     Request
//   Details:    Request page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101879 03/07/19 JC  M01  Can now copy from another request
// 101888 05/07/19 JC  M02  Can now cancel future dated accepted
//  84474 26/09/19 JC  M03  Need to URI encode the site
// 105066 06/01/20 JC  M04  Added font awesome
// 103839 06/04/20 JC  M05  React upgrade
// 108238 09/06/20 JC  M06  Re-wrote datetime components
// 115164 12/10/21 JC  M07JC	Added day parts, hours
// WI2231 24/01/23 JC  M08JC	Applied key to dayPart label
// WI2232 25/01/23 JC  M09JC	Added SpecificDays
// WI2242 26/01/23 JC  M10JC	Added IsAmendingApproved
// WI4743 25/02/25 JC  M11JC	Added WorkingDays panel
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import { Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { history } from '../history';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//M06JC import Moment from 'react-moment'; 
import moment from 'moment';//M07JC
import DateTime from '../components/DateTime'; //M06
import { dateTimeTypes } from '../constants/DateTimeTypes'; //M06
import { requestActions } from '../store/Request';
import Header from '../components/Header';
import Loading from '../components/Loading';
import AlertPanel from '../components/AlertPanel';
import Checkbox from '../components/Checkbox';
import Dialog from '../components/Dialog';
import NoItems from '../components/NoItems';
//M04 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M04
import { requestTypes } from '../constants/RequestTypes';
import { dayPartEnum } from '../constants/DayPartEnum'; //M07JC
import RequestCheckResponse from '../components/RequestCheckResponse';
import RequestWorkingTimes from '../components/RequestWorkingTimes';//M11JC
import { requestUtils } from '../utils/requestUtils'; //M05
import { utils } from '../utils/utils'; //M06
import TCSInputNumeric from '../components/TCSInputNumeric' //M07JC

const requestStatuses = {
	pending: 1,
	accepted: 2,
	rejected: 3,
	cancelled: 4, //M10JC
	rejection_acknowledged: 5, //M10JC
	pending_amendment_approval: 6 //M10JC
};

class Request extends Component {

	constructor(props) {
		super(props);

		this.state = requestUtils.getStateObject(props); //M05

		this.handleChange = this.handleChange.bind(this);
		this.handleFromDatetimeChange = this.handleFromDatetimeChange.bind(this); //M06
		this.handleToDatetimeChange = this.handleToDatetimeChange.bind(this); //M06
		this.handleIsSpecificDaysSelect = this.handleIsSpecificDaysSelect.bind(this); //M09JC
		this.handleSpecificDaySelect = this.handleSpecificDaySelect.bind(this); //M09JC
		this.handleReasonSelect = this.handleReasonSelect.bind(this);
		this.handleSiteSelect = this.handleSiteSelect.bind(this);
		this.handleTypeChanged = this.handleTypeChanged.bind(this);
		this.handleDayPartTypeChanged = this.handleDayPartTypeChanged.bind(this); //M07JC
		this.handleHoursChanged = this.handleHoursChanged.bind(this); //M07JC
		this.handleHoursBlur = this.handleHoursBlur.bind(this); //M07JC

		this.handleBack = this.handleBack.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleCheck = this.handleCheck.bind(this);
		this.handleEdit = this.handleEdit.bind(this);

		this.handleAcknowledge = this.handleAcknowledge.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleConfirmCancel = this.handleConfirmCancel.bind(this);
		this.handleDismissCancel = this.handleDismissCancel.bind(this);
		this.handleChangeAcknowledge = this.handleChangeAcknowledge.bind(this); //M01
		this.handleShowWorkingTimes = this.handleShowWorkingTimes.bind(this); //M11JC
		this.handleShowRequest = this.handleShowRequest.bind(this); //M11JC
	}

	//this code is called immediately before mounting occurs, including the render()
	//M05 componentWillMount
	componentDidMount() {
		//pulls compnents off the route path paramers...
		const { requestId, date, copyfromid } = this.props.match.params; //M01 added copyfromid parameter
		//and passes into the props get
		this.props.get(requestId, date, copyfromid); //added copyfromid to get

		//M01 ensure not set to copy acknowledge (as may be on the props if changing a rejected request)
		this.props.setCopyAcknowledge(false);
	}

	//M05
	//   componentWillReceiveProps(nextProps) {
	//       //M01 also allow if copy acknowledge flagged
	//	if (nextProps.request && nextProps.request.timestamp !== this.state.timestamp) {
	//		this.setState(this.getStateObject(nextProps));
	//	}
	//}

	//M05
	static getDerivedStateFromProps(props, state) {
		//M01 also allow if copy acknowledge flagged
		if (props.request && props.request.timestamp !== state.timestamp) {

			//return new state
			return requestUtils.getStateObject(props);
		}

		// Return null to indicate no change to state.
		return null;
	}

	//M05 moved to requestUtils
	//   getStateObject(props) {
	//	const { request } = props;

	//	let absenceReasonId = "";
	//	let sites = [];

	//	if (request) {
	//		if (request.absenceReasons) {
	//			absenceReasonId = request.absenceReasons.filter((item, i) => {
	//				return item.isSelected;
	//			});

	//			if (absenceReasonId.length > 0)
	//				absenceReasonId = absenceReasonId[0].absenceReasonId;
	//			else
	//				absenceReasonId = "";
	//		}

	//		sites = request.sites.map((item, i)=> {
	//			return { siteId: item.siteId, site: item.site, isSelected: item.isSelected };
	//		});
	//	}

	//	return {
	//		id: request ? request.id : 0,
	//		timestamp: request ? request.timestamp : 0,
	//		requestTypeId: request ? request.requestTypeId : requestTypes.holiday,
	//		fromDate: request ? request.fromDate : undefined,
	//		toDate: request ? request.toDate : undefined,
	//		sites,
	//		absenceReasonId,
	//		requestNote: request ? (request.requestNote || "") : "",
	//		requestType: request ? (request.requestType || "") : "",
	//		requestStatus: request ? (request.requestStatus || "") : "",
	//		processedNote: request ? (request.processedNote || "") : "",

	//		requestStatusEnum: request ? (request.requestStatusEnum || 1) : 1,

	//		canAmend: request ? request.canAmend : false,
	//		canCancel: request ? request.canCancel : false,
	//           canAcknowledge: request ? request.canAcknowledge : false,
	//           canChange: request ? request.canChange : false, //M01
	//		showCancelDialog: false,
	//		fromCalendar: request ? request.fromCalendar : undefined
	//	};
	//}


	validateForm() {
		const sitesSelected = this.state.sites.filter((item, i) => {
			return item.isSelected;
		});

		//M07JC added check to make sure hours exist if seleced
		const isValid = sitesSelected.length > 0
			&& (this.state.requestTypeId !== requestTypes.absence || this.state.absenceReasonId !== "")
			&& (this.state.dayPart !== dayPartEnum.hours || this.state.hours > 0); //M07JC

		return isValid;
	}

	// handle change of values event
	handleChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	//M06
	handleFromDatetimeChange = momentDate => {
		//M07JC if a moment date
		if (momentDate.hasOwnProperty("_isAMomentObject")) {

			//M09JC get other details from state for specific days
			let { isSpecificDays, specificDays } = this.state;

			//M07JC get the day part & hours from state
			let { dayPart, hours, toDate } = this.state;
			//if the date's not the same then get rid of the daypart & hours
			if (!momentDate.isSame(toDate, 'day')) {
				dayPart = dayPartEnum.full_day;
				hours = 0;				
			} else {
				//M09JC if the same, then disable is specific days
				isSpecificDays = false; 
			}
			
			//M09JC get the specific days
			specificDays = requestUtils.buildSpecificDays(isSpecificDays, specificDays, momentDate.toDate(), toDate);

			this.setState({
				fromDate: momentDate.toDate(), //M07JC
				dayPart: dayPart, //M07JC
				hours: hours, //M07JC
				isSpecificDays: isSpecificDays, //M09JC
				specificDays: specificDays //M09JC
			});
		}
	}

	//M06
	handleToDatetimeChange = momentDate => {
		//M07JC if a moment date
		if (momentDate.hasOwnProperty("_isAMomentObject")) {

			//M09JC get other details from state for specific days
			let { isSpecificDays, specificDays } = this.state;

			//M07JC get the day part & hours from state
			let { dayPart, hours, fromDate } = this.state;
			//if the date's not the same then get rid of the daypart & hours
			if (!momentDate.isSame(fromDate, 'day')) {
				dayPart = dayPartEnum.full_day;
				hours = 0;
			} else {
				//M09JC if the same, then disable is specific days
				isSpecificDays = false;
			}
			
			//M09JC get the specific days
			specificDays = requestUtils.buildSpecificDays(isSpecificDays, specificDays, fromDate, momentDate.toDate());

			this.setState({
				toDate: momentDate.toDate(), //M07JC
				dayPart: dayPart, //M07JC
				hours: hours, //M07JC
				isSpecificDays: isSpecificDays, //M09JC
				specificDays: specificDays //M09JC
			});
		}
	}

	// M09JC handle is specific days select
	handleIsSpecificDaysSelect = (item) => {
		//get the check state
		let isSpecificDays = item.checked;

		//get other details from state
		let { specificDays, fromDate, toDate } = this.state;

		//get the specific days
		specificDays = requestUtils.buildSpecificDays(isSpecificDays, specificDays, fromDate, toDate);

		this.setState({
			isSpecificDays: isSpecificDays,
			specificDays: specificDays
		});
	}

	//M09JC handle specific date select handleSpecificDaySelect
	handleSpecificDaySelect = (item) => {
		//get the from date from the sate
		let { fromDate } = this.state;

		//use this to get the specific date, note the item id is offset from the from date as itemId is a number
		let specificDate = moment.utc(fromDate).add(item.itemId, 'days').toDate();

		const specificDay = this.state.specificDays.filter((filterItem, i) => {
			return moment.utc(filterItem.specificDate).isSame(moment.utc(specificDate), 'day');
		});

		if (specificDay.length) {
			const modifySpecificDay= {
				...specificDay[0],
				isIncluded: item.checked
			};

			let index = this.state.specificDays.indexOf(specificDay[0]);
			let specificDays = this.state.specificDays.slice(0, index)
				.concat(modifySpecificDay)
				.concat(this.state.specificDays.slice(index + 1)
				);
			this.setState({ specificDays: specificDays });
		}
	}

	// handle reason select event
	handleReasonSelect = event => {
		this.setState({
			absenceReasonId: event.target.value
		});
	}

	// handle site select event
	handleSiteSelect = (item) => {
		const site = this.state.sites.filter((filterItem, i) => {
			return filterItem.siteId === item.itemId;
		});

		if (site.length) {
			const modifySite = {
				...site[0],
				isSelected: item.checked
			};

			let index = this.state.sites.indexOf(site[0]);
			let sites = this.state.sites.slice(0, index)
				.concat(modifySite)
				.concat(this.state.sites.slice(index + 1)
				);
			this.setState({ sites: sites });
		}
	}

	// handle type changed event (holiday/absence at present)
	handleTypeChanged = event => {
		const value = event.target.value;
		this.setState({
			requestTypeId: +value
		});
	}

	// M07JC handle day part type changed event 
	handleDayPartTypeChanged = event => {
		const value = event.target.value;

		//M07JC get the hours from state
		let { hours } = this.state;
		//if the date's not the same then get rid of the daypart & hours
		if (value !== dayPartEnum.hours) {
			hours = 0;
		}

		this.setState({
			dayPart: +value,
			hours: hours
		});
	}

	// M07JC handle hours changed
	handleHoursChanged = event => {
		//simply set in state
		var newHours = Number(event.target.value);
		this.setState({
			hours: newHours,
			editingHours: true
		});
	}

	// M07JC handle hours blur (leave)
	handleHoursBlur = event => {
		event.preventDefault();
		var newHours = utils.formatValue(event.target.value, "number", 2); //format as 2 dp number rather than using Number(event.target.value);

		//prevent being < 0 & > 24
		if (newHours < 0) { newHours = 0; }
		if (newHours > 24) { newHours = 24; }

		this.setState({
			hours: newHours,
			editingHours: false
		});

		//pass to parent to update
		//this.props.handleHoursBlur(this.props.index, newRate);
	}

	// handle save event
	handleSave = event => {
		event.preventDefault();
		this.props.save(
			this.state.id,
			this.state.requestTypeId,
			this.state.absenceReasonId,
			this.state.fromDate,
			this.state.toDate,
			this.state.isSpecificDays, //M09JC
			this.state.specificDays, //M09JC
			this.state.sites,
			this.state.requestNote,
			this.state.dayPart, //M07JC
			this.state.hours //M07JC
		);
	}

	// handle back event
	handleBack = event => {
		event.preventDefault();
		const { fromCalendar } = this.props;
		if (fromCalendar) {
			const { siteId, site, year, month } = fromCalendar;
			history.push(`/myplan/site/${siteId}/${encodeURIComponent(site)}/${year}/${month}`); //M03
		}
		else {
			history.push(`/myrequests`);
		}
	}

	// handle edit event
	handleEdit = event => {
		this.props.clearCheck();
	}

	// handle acknowledge event
	handleAcknowledge = event => {
		const { requestId } = this.props.match.params;
		this.props.acknowledge(requestId);
	}

	//handle change acknowledge event
	handleChangeAcknowledge = event => {

		//flag to store that we're going to copy acknowledge (actual copy is done in store navigateAwayFromRequest after acknowledge)
		this.props.setCopyAcknowledge(true)

		//and pass to handle acknowledge event
		this.handleAcknowledge(event);
	}

	//handle cancel event
	handleCancel = event => {
		this.setState({ showCancelDialog: true });
	}

	//handle confirm event
	handleConfirmCancel = event => {
		this.setState({ showCancelDialog: false });
		const { requestId } = this.props.match.params;
		this.props.cancel(requestId);
	}

	//handle dismiss cancel event
	handleDismissCancel = event => {
		this.setState({ showCancelDialog: false });
	}

	//handle check event
	handleCheck = event => {
		event.preventDefault();
		this.props.check(
			this.state.id,
			this.state.requestTypeId,
			this.state.absenceReasonId,
			this.state.fromDate,
			this.state.toDate,
			this.state.isSpecificDays, //M09JC
			this.state.specificDays, //M09JC
			this.state.sites,
			this.state.requestNote,
			this.state.dayPart, //M07JC
			this.state.hours, //M07JC
		);
	}

	// M11JC handle show working times click
	handleShowWorkingTimes = event => {
		this.setState({ showWorkingTimes: !this.state.showWorkingTimes});
	}

	// M11JC handle show request click
	handleShowRequest = event => {
		this.setState({ showRequest: !this.state.showRequest });
	}

	render() {
		const { isLoading, request, error, checkResponse, fromCalendar } = this.props;
		const { requestTypeId, absenceReasonId, fromDate, toDate, sites, canAmend, canCancel, canAcknowledge, showCancelDialog, canChange,
			dayPart, hours, editingHours, isSpecificDays, specificDays, isAmendingApproved,
			workingTimes, hasWorkingTimes, workingTimeLength, showWorkingTimes, showWorkingTimesButton,
			showRequest, showRequestButton} = this.state;
		//M01 added can change //M07JC M09JC M10JC M11JC

		const isNewRequest = this.state.id === 0;
		const disableEdit = requestTypeId === requestTypes.holiday && checkResponse;

		const showSave = canAmend && (requestTypeId === requestTypes.absence || checkResponse);
		const showCheck = canAmend && requestTypeId === requestTypes.holiday && !checkResponse;
		const showEdit = canAmend && disableEdit;

		const showAcknowledge = canAcknowledge;
		const showCancel = canCancel && !disableEdit;
		const showChange = canChange; //determine whether we should show change button

		const backTitle = fromCalendar
			? "Back to Calendar"
			: "Back to My Requests";

		//M11JC handle working times and logic reorder
		let title = "Request Details";
		if (!showRequest && showWorkingTimes) {
			title = "Working Times";
		} else if (showRequest && canAmend) {
			title = `${isNewRequest ? "New" : "Edit"} Request`;
		}

		//M11JC
		const buttonWorkingTimesTitle = showWorkingTimes
			? "Hide working times"
			: "Show working times";

		//M11JC
		const buttonRequestTitle = showRequest
			? "Hide request"
			: `${isNewRequest ? "Add" : "Edit"} request`;

		//M09JC 
		const sameDay = fromDate !== undefined && toDate !== undefined && moment.utc(fromDate).isSame(moment.utc(toDate), 'day');

		//M07JC - determine if we should enable part - only when from date = to date
		const enableDayPart = sameDay; //M09JC

		//M07JC - determine if we should enable hours - only when day part = hours
		const enableHours = dayPart !== undefined && dayPart === dayPartEnum.hours;

		//M09JC - determine if we can show specific days - only if from date not the same as to date
		const enableSpecificDays = !sameDay;

		//M09JC - show specific days - only if the request isn't accepted or pending amendment approval
		const showSpecificDays = request && request.requestStatusEnum !== requestStatuses.accepted &&
			request.requestStatusEnum !== requestStatuses.pending_amendment_approval

		return (
			<div>
				<Header title={title} />

				<div className="button-tray top">
					<div className="btn-group">
					<button type="button" className="btn btn-default btn-dftleftpadding btn-dfttoppadding" onClick={this.handleBack}><FontAwesomeIcon icon="chevron-left" /> {backTitle}</button> {/* M04 */}
					{showWorkingTimesButton ? /*M11JC*/
						<button type="button" className="btn btn-default btn-dftleftpadding btn-dfttoppadding" onClick={this.handleShowWorkingTimes}><FontAwesomeIcon icon="clock" /> {buttonWorkingTimesTitle}</button> /* M11JC */
						: []}
					{showRequestButton? /*M11JC*/
						<button type="button" className="btn btn-default btn-dftleftpadding btn-dfttoppadding" onClick={this.handleShowRequest}><FontAwesomeIcon icon="info-circle" /> {buttonRequestTitle}</button> /* M11JC */
						: []}
					</div>
				</div>

				<div>
					{showCancelDialog
						? <Dialog title="Delete Request" message="Do you wish to delete this request?" onConfirm={this.handleConfirmCancel} onCancel={this.handleDismissCancel} confirmClass="btn-destructive" confirmText="Delete" />
						: []}

					{error ? <AlertPanel type="danger" message={error} /> : []}


					{(showSave && this.state.requestTypeId === requestTypes.holiday) ?
						/*M01 - if show save on holiday, need to put up an alert panel to inform user they still need to save */
						<AlertPanel type="info" message="Press save to confirm your request." />
						: []
					}

					{isLoading ? <Loading /> : []}
					{request ?
						//amend mode
						canAmend
							?
							<form onSubmit={this.handleSave}>
								{/*M11JC*/}
								<RequestWorkingTimes key="RequestWorkingTimes"
									showWorkingTimes={showWorkingTimes}
									workingTimes={workingTimes}
									hasWorkingTimes={hasWorkingTimes}
									workingTimeLength={workingTimeLength}
								/>
								{showRequest ? /*M11JC*/
									<div>
										<Row>
											<Col sm={3}>
												<label>Type</label>
											</Col>
											<Col sm={9}>
												<label>
													<input type="radio" name="requestType" value={requestTypes.holiday} checked={requestTypeId === requestTypes.holiday} onChange={this.handleTypeChanged} disabled={disableEdit || isAmendingApproved} /> {/*M10JC*/}
													Holiday
												</label>
												&nbsp;&nbsp;&nbsp;
												<label>
													<input type="radio" name="requestType" value={requestTypes.absence} checked={requestTypeId === requestTypes.absence} onChange={this.handleTypeChanged} disabled={disableEdit || isAmendingApproved} /> {/*M10JC*/}
												</label>
												Absence
											</Col>
										</Row>
										{this.state.requestTypeId === requestTypes.absence
											? <Row>
												<Col sm={3}>
													<label>Reason</label>
												</Col>
												<Col sm={9}>
													<select id="absenceReason" onChange={this.handleReasonSelect} value={absenceReasonId} disabled={isAmendingApproved}> {/*M08JC*/}
														<option value="">Select a reason...</option>
														{request.absenceReasons.map((reason) => <option key={reason.absenceReasonId} value={reason.absenceReasonId}>{reason.absenceReason}</option>)}
													</select>
												</Col>
											</Row>
											: []}

										<Row>
											<Col sm={3}>
												<label>Date from</label>
											</Col>
											<Col sm={9}>
												{/* M06 re-written below 
										<input
											id="fromDate"
											type="date"
											value={fromDate}
											onChange={this.handleChange}
											disabled={disableEdit}
                                        /> */}
												<DateTime
													componentKey="fromDate"
													componentName="fromDate"
													value={fromDate}
													onChange={this.handleFromDatetimeChange}
													dateTimeType={dateTimeTypes.date}
													disabled={disableEdit}
												/>
												{/* M06 */}
											</Col>
										</Row>
										<Row>
											<Col sm={3}>
												<label>Date to</label>
											</Col>
											<Col sm={9}>
												{/* M06 re-written below 
										<input
											id="toDate"
											type="date"
											value={toDate}
											onChange={this.handleChange}
											disabled={disableEdit}
                                        /> */}
												<DateTime
													componentKey="toDate"
													componentName="toDate"
													value={toDate}
													onChange={this.handleToDatetimeChange}
													dateTimeType={dateTimeTypes.date}
													disabled={disableEdit}
												/>
												{/* M06 */}
											</Col>
										</Row>

										{/* M09JC specific days checkbox? */
											showSpecificDays ?
												<Row>
													<Col sm={3}>
													</Col>
													<Col sm={9}>
														<Checkbox key="specificdays" name="Specific days?" checked={isSpecificDays} changed={this.handleIsSpecificDaysSelect} disabled={disableEdit || !enableSpecificDays} />
													</Col>
												</Row>
												: []}

										{/* M09JC specific days? */
											isSpecificDays ?
												<Row>
													<Col sm={3}>
														<label>Specific days</label>
													</Col>
													<Col sm={9}>
														{specificDays.map((item, key) =>
															<Checkbox
																key={key}
																name={moment.utc(item.specificDate).format(utils.getDayAndDateFormat())}
																itemId={key} /* using key as an offset */
																checked={item.isIncluded}
																changed={this.handleSpecificDaySelect}
																disabled={disableEdit} />
														)}
													</Col>
												</Row>
												: []}

										{/* M07JC day part type radio */}
										<Row>
											<Col sm={3}>
												<label>Day part</label>
											</Col>
											<Col sm={9}>
												{Object.values(dayPartEnum).map((i, j) =>
													<label key={`dayPartlabel${j}`}> {/*M08JC*/}
														<input
															key={`dayPart${j}`}
															type="radio"
															name={`dayPart${j}`}
															value={i}
															checked={dayPart === i}
															onChange={this.handleDayPartTypeChanged}
															disabled={disableEdit || (!enableDayPart) || isAmendingApproved} /> {/*M10JC*/}
														{utils.formatEnumString(Object.keys(dayPartEnum)[j])}
														&nbsp;&nbsp;&nbsp;
													</label>
												)}
											</Col>
										</Row>

										{/* M07JC hours */}
										<Row>
											<Col sm={3}>
												<label>Hours</label>
											</Col>
											<Col sm={9}>
												<TCSInputNumeric className="float-left width100"
													key='hours'
													name='hours'
													value={editingHours ? hours : utils.formatValue(hours, "number", 2)} //don't apply format if editing
													disabled={disableEdit || (!enableHours) || isAmendingApproved} /*M10JC*/
													onChange={this.handleHoursChanged}
													onBlur={this.handleHoursBlur}
													min={0} max={24}
													step='any'
												/>
											</Col>
										</Row>

										<Row>
											<Col sm={3}>
												<label>Site</label>
											</Col>
											<Col sm={9}>
												{sites.map(item =>
													<Checkbox key={item.siteId} name={item.site} itemId={item.siteId} checked={item.isSelected} changed={this.handleSiteSelect} disabled={disableEdit || isAmendingApproved} /> /*M10JC*/
												)}
											</Col>
										</Row>



										<Row>
											<Col sm={3}>
												<label>Details</label>
											</Col>
											<Col sm={9}>
												<textarea
													id="requestNote"
													value={this.state.requestNote}
													onChange={this.handleChange}
													disabled={disableEdit || isAmendingApproved} /*M10JC*/
												/>
											</Col>
										</Row>
										<br />
										{checkResponse
											? <Row>
												<Col sm={3}>
													<label>Request check</label>
												</Col>
												<Col sm={9}>
													{checkResponse.length === 0
														? <NoItems />
														: []}
													{checkResponse.map(item =>
														<RequestCheckResponse key={item.site} site={item.site} details={item.details} status={item.status} />
													)}
												</Col>
											</Row>
											: []}
										<div className="button-tray bottom">
											{showSave ? <button type="submit" className="btn btn-success" disabled={!this.validateForm()}>Save</button> : []}
											{showCheck ? <button type="button" className="btn btn-success" onClick={this.handleCheck} disabled={!this.validateForm()}>Check</button> : []}
											{showEdit ? <button type="button" className="btn btn-default" onClick={this.handleEdit} disabled={!this.validateForm()}>Edit</button> : []}
											{showCancel ? <button type="button" className="btn btn-destructive float-right" onClick={this.handleCancel} disabled={!this.validateForm()}><FontAwesomeIcon icon="trash-alt" /> Delete request</button> : []} {/* M04 */}
										</div>
									</div> : []}
							</form>

							/* view mode */
							: <div>
								{/*M11JC*/}
								<RequestWorkingTimes key="RequestWorkingTimes"
									showWorkingTimes={showWorkingTimes}
									workingTimes={workingTimes}
									hasWorkingTimes={hasWorkingTimes}
									workingTimeLength={workingTimeLength}
								/>
								{showRequest ? /*M11JC*/
									<div>
								<Row>
									<Col sm={3}>
										<label>Type</label>
									</Col>
									<Col sm={9}>
										{this.state.requestType}
									</Col>
								</Row>
								<Row>
									<Col sm={3}>
										<label>Status</label>
									</Col>
									<Col sm={9}>
										{this.state.requestStatusEnum === requestStatuses.accepted ? <FontAwesomeIcon icon="check" /> : []} {/* M04 */}
										{this.state.requestStatusEnum === requestStatuses.rejected ? <FontAwesomeIcon icon="times" /> : []} {/* M04 */}
										&nbsp;{this.state.requestStatus}
									</Col>
								</Row>
								{this.state.requestStatusEnum === requestStatuses.rejected && this.state.processedNote
									? <Row>
										<Col sm={3}>
											<label>Rejection note</label>
										</Col>
										<Col sm={9}>
											<div>{this.state.processedNote}</div>
										</Col>
									</Row>
									: []}
								<Row>
									<Col sm={3}>
										<label>Date from</label>
									</Col>
									<Col sm={9}>
										<DateTime value={this.state.fromDate} dateTimeType={dateTimeTypes.date} disabled={true} />{/* M06 */}
									</Col>
								</Row>
								<Row>
									<Col sm={3}>
										<label>Date to</label>
									</Col>
									<Col sm={9}>
										<DateTime value={this.state.toDate} dateTimeType={dateTimeTypes.date} disabled={true} />{/* M06 */}
									</Col>
								</Row>

								{/* M07JC day part - we iterate through each enum value and print the text if it matches */}
								<Row>
									<Col sm={3}>
										<label>Day part</label>
									</Col>
									<Col sm={9}>
										{Object.values(dayPartEnum).map((i, j) =>
											dayPart === i ?
												<label>{utils.formatEnumString(Object.keys(dayPartEnum)[j]) +
													(i === dayPartEnum.hours ? `: ${utils.formatValue(hours, "number", 2)}` : "")}</label>
												: []
										)}
									</Col>
								</Row>

								<Row>
									<Col sm={3}>
										<label>Site</label>
									</Col>
									<Col sm={9}>
										{sites.map(item =>
											<div key={item.siteId}>{item.site}</div>
										)}
									</Col>
								</Row>
								{this.state.requestNote
									? <Row>
										<Col sm={3}>
											<label>Details</label>
										</Col>
										<Col sm={9}>

											{this.state.requestNote.split('\n').map((i, k) => {
												return <span>{i}<br /></span>;
											})}

										</Col>
									</Row>
											: []}
								{(showAcknowledge || showChange || showCancel)
									/*M01 if we should show acknowledge or change M02 or cancel, add buttons for this */
									? <div className="button-tray bottom">
										{showAcknowledge ? <button type="button" className="btn btn-default" onClick={this.handleAcknowledge} disabled={!this.validateForm()}>Acknowledge</button> : []}
										{showChange ? <button type="button" className="btn btn-default" onClick={this.handleChangeAcknowledge} disabled={!this.validateForm()}>Change</button> : []}
										{showCancel ? <button type="button" className="btn btn-destructive float-right" onClick={this.handleCancel} disabled={!this.validateForm()}><FontAwesomeIcon icon="trash-alt" /> Delete request</button> : []} {/* M04 */}
									</div>
											: []}
								</div> : [] /*M11JC*/}
							</div>
						: []
					}
				</div>
			</div>
		);
	}
}

Request.propTypes = {
	request: PropTypes.any,
	error: PropTypes.string,
	isLoading: PropTypes.bool,
	checkResponse: PropTypes.any

};

export default connect(
	state => (state.request),
	dispatch => bindActionCreators(requestActions, dispatch)
)(Request);
